import gql from "graphql-tag";

export const ALL_PERMISSIONS = gql`
    query ALL_PERMISSIONS($page: Int!, $perPage: Int!) {
        permissions (page: $page, perPage: $perPage) {
            objects {
                id,
                name,
                codename
            }
        }
    }
`;

export const ALL_ROLES = gql`
    query ALL_ROLES($page: Int!, $perPage: Int!) {
        roles (page: $page, perPage: $perPage) {
            objects {
                id,
                name,
                widgets {
                    id,
                    widget
                }
                permissions {
                    id,
                    name,
                    codename
                }
            }
        }
    }
`;

export const ADD_NEW_USER_ROLE = gql`
    mutation ADD_NEW_USER_ROLE($name: String!, $permissions: [PermissionInputType], $widgets: [String]){
        role(name: $name, permissions: $permissions, widgets: $widgets) {
            role {
                name
            }
        }
    }
`;

export const UPDATE_USER_ROLE = gql`
    mutation UPDATE_USER_ROLE($id: ID!,$name: String!, $permissions: [PermissionInputType], $widgets: [String]){
        role(id: $id, name: $name, permissions: $permissions, widgets: $widgets) {
            role {
                name
            }
        }
    }
`;

export const DELETE_USER_FROM_ROLE = gql`
    mutation DELETE_USER_FROM_ROLE($roleId: Int!,$userId: String!){
        deleteRoleAssignment(roleId: $roleId, userId: $userId) {
            message
        }
    }
`;

export const DELETE_PERMISSION_FROM_ROLE = gql`
    mutation DELETE_PERMISSION_FROM_ROLE($roleId: Int!,$permissionId: Int!){
        removeRolePermission(roleId: $roleId, permissionId: $permissionId) {
            message
        }
    }
`;

export const DELETE_WIDGET_FROM_ROLE = gql`
    mutation DELETE_WIDGET_FROM_ROLE($id: ID!){
        deleteRoleWidget(id: $id) {
            message
        }
    }
`;

export const SINGLE_USER_ROLE = gql`
    query SINGLE_USER_ROLE($id: Int!) {
        role (id: $id) {
            id,
            name,
            permissions {
                id,
                name,
                codename
            }
            usersPaginated (page: 1, perPage: 30) {
                page,
                pages,
                total,
                nextPage,
                previousPage,
                hasNext,
                hasPrevious,
                objects {
                    publicId,
                    name,
                    email,
                    phoneNumber,
                    isActive
                }
            }
            widgets {
                id,
                widget
            }
        }
    }
`;

// CUSTOMER TIERS
export const ALL_CUSTOMER_TIERS = gql`
    query ALL_CUSTOMER_TIERS($page: Int!, $perPage: Int!) {
        tiers (page: $page, perPage: $perPage) {
            objects {
                publicId,
                name,
                description,
                minimumInvoiceTotal,
                createdAt,
                updatedAt,
            }
        }
    }
`;

export const ADD_NEW_CUSTOMER_TIER = gql`
    mutation ADD_NEW_CUSTOMER_TIER($name: String!, $description: String!, $minimumInvoiceTotal: Float!){
        tier(name: $name, description: $description, minimumInvoiceTotal: $minimumInvoiceTotal) {
            tier {
                publicId,
                name,
                description,
                minimumInvoiceTotal,
                createdAt,
                updatedAt
            }
        }
    }
`;

export const UPDATE_CUSTOMER_TIER = gql`
    mutation UPDATE_CUSTOMER_TIER($id: ID!,$name: String!, $description: String!, $minimumInvoiceTotal: Float!){
        tier(id: $id, name: $name, description: $description, minimumInvoiceTotal: $minimumInvoiceTotal) {
            tier {
                publicId,
                name,
                description,
                minimumInvoiceTotal,
                createdAt,
                updatedAt
            }
        }
    }
`;


// CUSTOMER TYPES
export const ALL_CUSTOMER_TYPES = gql`
    query ALL_CUSTOMER_TYPES($page: Int!, $perPage: Int!, $searchKeyword: String) {
        institutionTypes (page: $page, perPage: $perPage, searchKeyword: $searchKeyword) {
            objects {
                publicId,
                name,
                description,
                shortCode,
                tier {
                    publicId,
                    name,
                    description,
                    minimumInvoiceTotal
                }
            }
        }
    }
`;

export const ADD_NEW_CUSTOMER_TYPE = gql`
    mutation ADD_NEW_CUSTOMER_TYPE($name: String!, $description: String!, $shortCode: String!, $tier: String!){
        institutionType(name: $name, description: $description, shortCode: $shortCode, tier: $tier) {
            institutionType {
                publicId,
                name,
            }
        }
    }
`;

export const UPDATE_CUSTOMER_TYPE = gql`
    mutation UPDATE_CUSTOMER_TYPE($id: ID!,$name: String!, $description: String!, $shortCode: String!, $tier: String!){
        institutionType(id: $id, name: $name, description: $description, shortCode: $shortCode, tier: $tier) {
            institutionType {
                publicId,
                name,
            }
        }
    }
`;
